import { mapActions , mapMutations , mapState} from 'vuex';
import $store from '@/store';
import $router from '@/router';


export default Object.assign({
    $store,
    $router,
}, mapActions(['alert','loadUser']),mapMutations(['showLoader','setUser','logOut']),mapState(['user'])
)